var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 8.53872C20 8.26515 19.8968 7.99158 19.711 7.79461L18.3071 6.3064C18.1213 6.10943 17.8632 6 17.6052 6C17.3471 6 17.089 6.10943 16.9032 6.3064L10.1316 13.4958L7.09677 10.2677C6.91097 10.0707 6.6529 9.96128 6.39484 9.96128C6.13677 9.96128 5.87871 10.0707 5.6929 10.2677L4.28903 11.7559C4.10323 11.9529 4 12.2264 4 12.5C4 12.7736 4.10323 13.0471 4.28903 13.2441L9.42968 18.6936C9.61548 18.8906 9.87355 19 10.1316 19C10.3897 19 10.6477 18.8906 10.8335 18.6936L19.711 9.28283C19.8968 9.08586 20 8.81229 20 8.53872Z",
    fill: "#52CF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c96b61cf.svg";
export { ForwardRef as ReactComponent };